module.exports = __webpack_public_path__ + "static/ux_4_eg-d216de29f3b5703c8cf6a7fbc6a672d1.png";